import type { UserProfile } from '~/pages/common/UserProfile/helpers';
import { getAxiosClient, sortByName } from './common';

const axios = getAxiosClient();

export async function getMe(token: string) {
  const { data } = await axios({
    method: 'GET',
    url: `/v1/users/me`,
    ...(token
      ? {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      : {}),
  });

  const orgs = sortByName(data.organizations);
  return {
    ...data,
    organizations: orgs,
  };
}

export async function userCompletedVerification() {
  const { data } = await axios({
    method: 'GET',
    url: `/v1/users/userCompletedVerification`,
  });
  return data;
}

export async function userFailedVerification() {
  const { data } = await axios({
    method: 'GET',
    url: `/v1/users/failedVerification`,
  });
  return data;
}

export async function checkIfDomainAllowed() {
  const { data } = await axios({
    method: 'GET',
    url: `/v1/users/checkIfDomainAllowed`,
  });
  return data;
}

export async function updateProfile(profile: UserProfile) {
  const response = await axios({
    method: 'PUT',
    url: `/v1/users/updateProfile`,
    data: { profile },
  });

  return response;
}

export async function createOrganizationByUser(organizationName: string) {
  const response = await axios({
    method: 'POST',
    url: `/v1/users/createOrganization`,
    data: { organizationName },
  });

  return response;
}

export async function updateBookmarks(projectId: string) {
  const response = await axios({
    method: 'PUT',
    url: `/v1/users/preferences/projectBookmarks`,
    data: { projectId },
  });

  return response;
}

export async function skipVerification() {
  const { data } = await axios({
    method: 'GET',
    url: `/v1/users/skipVerification`,
  });
  return data;
}
